import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Image, Button, Icon, Header, Label } from 'semantic-ui-react';
import i18next from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { exportDataToExcel } from '../../../helpers/excel';

import PagesIcon from '../../../assets/icons/pages.svg';
import PagesIconActive from '../../../assets/icons/pages-active.svg';
import './DataGrid.scss';

class ManagementPanel extends Component {

    constructor(props) {
        super(props);

        this.exportPresentedDataToExcel = this.exportPresentedDataToExcel.bind(this);
        this.renderStatistics = this.renderStatistics.bind(this);
    }

    formatDataForExport(data) {
        return data.map(row => {
            return Object.keys(row).filter(key =>
                !key.startsWith("_") && key !== 'index' && key !== 'actions'
            ).reduce((obj, key) => {
                obj[key] = row[key];
                return obj;
            }, {});
        });
    }

    exportPresentedDataToExcel() {
        const { getGridState } = this.props;
        const { sortedData } = getGridState();
        const dataToExport = this.formatDataForExport(sortedData);

        exportDataToExcel("grid_data", "data", dataToExport);
    }

    renderStatistics() {
        const { data, filteredResults } = this.props;

        return (
            <div className='pi-data-grid-statistics'>
                <Label.Group>
                    <Label color="grey" basic>
                        {data.length}
                        <Label.Detail>{i18next.t("dataGrid.records")}</Label.Detail>
                    </Label>
                    {
                        filteredResults !== data.length ?
                            <Label pointing="left" color="grey" basic>
                                {filteredResults}
                                <Label.Detail>{i18next.t("dataGrid.results")}</Label.Detail>
                            </Label>
                            : null
                    }
                </Label.Group>
            </div>
        );
    }

    render() {
        const { extraActions, extraInfo, showFilters, resizable, isPaginated, actionTriggered } = this.props;

        return (
            <div className="pi-data-grid-actions-panel">
                <Button.Group className="pi-data-grid-actions-panel-buttons-1">
                    <Button icon
                        color={showFilters ? 'teal' : null}
                        onClick={() => actionTriggered({ filterMode: showFilters ? undefined : true })}
                    >
                        <FontAwesomeIcon icon="filter" />
                    </Button>
                    <Button icon
                        color={resizable ? 'teal' : null}
                        onClick={() => actionTriggered({ resizeMode: resizable ? undefined : true })}
                    >
                        <FontAwesomeIcon icon="arrows-alt-h" />
                    </Button>
                    {/* <Button icon
                        color={isPaginated ? 'teal' : null}
                        onClick={() => actionTriggered('showAllRows', !isPaginated)}
                        className="pi-data-grid-actions-panel-pages-button"
                    >
                        <Image src={isPaginated ? PagesIconActive : PagesIcon } />
                    </Button> */}
                </Button.Group>
                <Button.Group className="pi-data-grid-actions-panel-buttons-2">
                    <Button type='button' labelPosition='left' icon
                        onClick={this.exportPresentedDataToExcel}
                        className='pi-workers-excel-button'
                    >
                        <FontAwesomeIcon icon='file-excel' transform="shrink-8" className="icon" />
                        {i18next.t('excel.export')}
                    </Button>
                </Button.Group>
                {this.renderStatistics()}
                <div className="pi-data-grid-actions-panel-extra-info">
                    {extraInfo}
                </div>
                <div className="pi-data-grid-actions-panel-extra-actions">
                    {extraActions}
                </div>
            </div>
        );
    }
}

ManagementPanel.propTypes = {
    data: PropTypes.array.isRequired,
    getGridState: PropTypes.func.isRequired,
    filteredResults: PropTypes.number.isRequired,
    showFilters: PropTypes.bool.isRequired,
    resizable: PropTypes.bool.isRequired,
    isPaginated: PropTypes.bool.isRequired,
    actionTriggered: PropTypes.func.isRequired,
    extraActions: PropTypes.node,
    extraInfo: PropTypes.node,
};

export default ManagementPanel;